import React from 'react'

export default () => (
    <div className="noDataComponentWrapper">
        <div className="noDataComponentText">
            No Data
        </div>
    </div>
)